import { combineReducers } from "@reduxjs/toolkit";
import { NotificationReducer } from "./notificationSlice";

const reducers = combineReducers({notification: NotificationReducer});

export default reducers;